module.exports = __webpack_public_path__ + "img/pantalla 7-11.402f8b00.svg";